import { useTranslation } from 'next-i18next';
import { useCallback } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import { closeModalForm } from '../../redux/slices/showPhoneForm';
import { RootState } from '../../redux/store';
import Content from './Content';
import Footer from './Footer';
import StyledForm from './StyledForm';
import StyledModal from './StyledModal';

export type ShowPhoneFormProps = {
  onSubmit: () => void;
};

const ShowPhoneForm: React.FC<ShowPhoneFormProps> = ({ onSubmit, ...rest }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation('property');

  const { isFormOpen } = useSelector(
    (state: RootState) => ({
      isFormOpen: state.showPhoneForm.isFormOpen
    }),
    shallowEqual
  );

  const handleOnClose = useCallback(() => {
    dispatch(closeModalForm());
  }, [dispatch]);

  const onSubmitForm = useCallback(
    (e: React.FormEvent<HTMLFormElement>) => {
      e.preventDefault();
      onSubmit();
    },
    [onSubmit]
  );

  return (
    <StyledModal
      isOpen={isFormOpen}
      onClose={handleOnClose}
      onBackdropClick={handleOnClose}
      title={t('completeDataToShowPhone').toString()}
      titleAlign='left'
    >
      <StyledForm
        onSubmit={onSubmitForm}
        noValidate
        {...rest}
      >
        <Content />
        <Footer />
      </StyledForm>
    </StyledModal>
  );
};
export default ShowPhoneForm;
